<template>
    <div class="sc-suggestions-row">
         <!-- :style="{background: colors.messageList.bg}" -->
        <button class="sc-suggestions-element" v-for="(suggestion, idx) in suggestions" v-on:click="$emit('sendSuggestion', suggestion)" 
         :key="idx">{{suggestion}}</button>
         <!-- :style="{borderColor: colors.sentMessage.bg, color: colors.sentMessage.bg}" -->
    </div>
</template>

<script>
export default {
    data() {
        return {
        }
    },
    props: {
        suggestions: {
            type: Array,
            default: () => []
        },
        // colors: {
        //     type: Object,
        //     required: true
        // }
    }
}
</script>

<style>
@import "./styles/suggestions.css";
</style>



// WEBPACK FOOTER //
// src/components/beautiful-chat/Suggestions.vue